/*
  Loom Decor – accessibility fixes (Level Access / WCAG 2.2 AA findings)
  Runtime patches for markup that comes from apps (Qikify Smart Menu, Klaviyo
  popup) and from legacy page / policy / blog content that can't be fixed in
  theme Liquid. Safe to run multiple times; re-runs on DOM changes.
*/
(function () {
  'use strict';

  var INTERNAL_HOSTS = ['loomdecor.com', 'www.loomdecor.com', 'loom-decor.myshopify.com'];
  var CONTACT_URL = '/pages/contact-us-at-loom-decor';

  function isInternal(host) {
    host = (host || '').toLowerCase();
    return INTERNAL_HOSTS.indexOf(host) > -1 || /\.shopifypreview\.com$/.test(host);
  }

  /* 2.4.4 – duplicate link names with "different" targets: same page linked as
     absolute (https://loomdecor.com/…, www., myshopify., old preview domain)
     and relative. Normalise every internal link to a site-relative URL. */
  function normaliseLinks(root) {
    var links = (root || document).querySelectorAll('a[href^="http"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var url;
      try { url = new URL(a.getAttribute('href'), location.href); } catch (e) { continue; }
      if (!isInternal(url.hostname)) continue;
      var rel = url.pathname + url.search + url.hash;
      if (rel !== a.getAttribute('href')) a.setAttribute('href', rel);
    }
  }

  /* 4.1.2 – anchors without href (legacy "Contact a Stylist" popup links) */
  function fixHrefLessLinks(root) {
    var links = (root || document).querySelectorAll('a.contact-popup:not([href])');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.textContent.trim()) {            // empty anchor – nothing to link
        a.parentNode && a.parentNode.removeChild(a);
      } else {
        a.setAttribute('href', CONTACT_URL);
        a.removeAttribute('tabindex');
      }
    }
  }

  /* 2.4.4 – "FAQ" alone is flagged as a link name without purpose */
  function labelFaqLinks(root) {
    var links = (root || document).querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.hasAttribute('aria-label')) continue;
      if (a.textContent.trim().toLowerCase() === 'faq') {
        a.setAttribute('aria-label', 'Frequently asked questions (FAQ)');
      }
    }
  }

  /* 1.3.1 – list items pasted from Google Docs carry role="presentation" */
  function fixListRoles(root) {
    var items = (root || document).querySelectorAll('ul > li[role="presentation"], ol > li[role="presentation"]');
    for (var i = 0; i < items.length; i++) items[i].removeAttribute('role');
  }

  /* 1.3.1 – nav landmarks need names when there is more than one.
     Qikify Smart Menu injects its own <nav> inside the header nav. */
  function labelNavs(root) {
    var navs = (root || document).querySelectorAll('nav.tmenu_navbar, nav.tmenu_app, .tmenu_wrapper nav');
    for (var i = 0; i < navs.length; i++) {
      if (!navs[i].hasAttribute('aria-label') && !navs[i].hasAttribute('aria-labelledby')) {
        navs[i].setAttribute('aria-label', 'Main menu');
      }
    }
  }

  /* 1.3.1 – Klaviyo popup: its only heading is an <h6>, which reads as a jump
     in the dialog's heading hierarchy. Expose it as a level-2 heading. */
  function fixKlaviyoHeadings(root) {
    var forms = (root || document).querySelectorAll('form.klaviyo-form');
    for (var f = 0; f < forms.length; f++) {
      var heads = forms[f].querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]');
      for (var i = 0; i < heads.length; i++) {
        var h = heads[i];
        if (h.getAttribute('role') !== 'heading') h.setAttribute('role', 'heading');
        if (h.getAttribute('aria-level') !== '2') h.setAttribute('aria-level', '2');
      }
    }
  }

  /* 4.1.2 – decorative SVGs injected by apps without a text alternative */
  function hideDecorativeSvgs(root) {
    var svgs = (root || document).querySelectorAll('.mw-tooltip--icon svg, .tmenu_wrapper svg, .klaviyo-form svg');
    for (var i = 0; i < svgs.length; i++) {
      var s = svgs[i];
      if (s.getAttribute('aria-hidden') || s.getAttribute('aria-label') || s.getAttribute('role') === 'img' || s.querySelector('title')) continue;
      s.setAttribute('aria-hidden', 'true');
      s.setAttribute('focusable', 'false');
    }
  }

  function run(root) {
    try {
      normaliseLinks(root);
      fixHrefLessLinks(root);
      labelFaqLinks(root);
      fixListRoles(root);
      labelNavs(root);
      fixKlaviyoHeadings(root);
      hideDecorativeSvgs(root);
    } catch (e) { /* never break the storefront */ }
  }

  function init() {
    run(document);
    if (!('MutationObserver' in window)) return;
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; run(document); }, 150);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-level', 'role'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
